import { FC } from 'react';
import type { DreContaSemClassificacao } from '@/types/dashboards';
import { fmtBRL } from '@/utils/painelFormat';

/** As contas que o de-para do Datasul não classifica: quem mantém o bi060 precisa delas. */
const ContasSemClassificacao: FC<{ contas: DreContaSemClassificacao[] }> = ({ contas }) => {
  if (!contas.length) return null;
  return (
    <details className="rounded-xl border border-theme-border bg-surface-card p-5 text-sm" data-testid="dre-sem-classificacao">
      <summary className="cursor-pointer font-semibold text-content-primary">
        Contas sem classificação no Datasul ({contas.length})
      </summary>
      <p className="mt-2 text-content-secondary">
        Têm lançamento no período, mas não estão na classificação da DRE do Datasul (programa bi060). Entram na linha
        própria, antes do resultado antes do IR: o lucro líquido não perde nada. Para irem para a linha certa, alguém da
        contabilidade ou do TI precisa classificá-las no bi060.
      </p>
      <table className="mt-3 w-full text-sm tabular-nums">
        <thead>
          <tr className="border-b border-theme-border text-xs uppercase tracking-wide text-content-muted">
            <th className="py-2 pr-3 text-left font-medium">Conta</th>
            <th className="py-2 pr-3 text-left font-medium">Descrição</th>
            <th className="py-2 pr-3 text-left font-medium">No Datasul</th>
            <th className="py-2 text-right font-medium">Total no período</th>
          </tr>
        </thead>
        <tbody>
          {contas.map((c) => (
            <tr key={c.conta} className="border-b border-theme-border/50">
              <td className="py-1.5 pr-3 font-mono text-xs">{c.conta}</td>
              <td className="py-1.5 pr-3">{c.descricao || '—'}</td>
              <td className="py-1.5 pr-3 text-content-muted">{c.classificacao_datasul ?? 'fora da classificação'}</td>
              <td className="py-1.5 text-right">{fmtBRL(c.total)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </details>
  );
};

export default ContasSemClassificacao;
